"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMasonry = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const react_masonry_css_1 = __importDefault(require("react-masonry-css"));
const PREFIX = "MasonryGrid";
exports.classes = {
    root: `${PREFIX}-root`,
    column: `${PREFIX}-column`
};
exports.StyledMasonry = (0, styles_1.styled)(react_masonry_css_1.default)(({ theme }) => ({
    [`&.${exports.classes.root}`]: {
        display: "flex",
        width: "inherit",
        marginLeft: "-24px" // Spacing * 3
    },
    [`.${exports.classes.column}`]: {
        paddingLeft: "24px"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21hc29ucnktZ3JpZC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLDBFQUF3QztBQUV4QyxNQUFNLE1BQU0sR0FBRyxhQUFhLENBQUM7QUFFaEIsUUFBQSxPQUFPLEdBQUc7SUFDckIsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0lBQ3RCLE1BQU0sRUFBRSxHQUFHLE1BQU0sU0FBUztDQUMzQixDQUFDO0FBRVcsUUFBQSxhQUFhLEdBQUcsSUFBQSxlQUFNLEVBQUMsMkJBQU8sQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUMzRCxDQUFDLEtBQUssZUFBTyxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7UUFDckIsT0FBTyxFQUFFLE1BQU07UUFDZixLQUFLLEVBQUUsU0FBUztRQUNoQixVQUFVLEVBQUUsT0FBTyxDQUFDLGNBQWM7S0FDbkM7SUFFRCxDQUFDLElBQUksZUFBTyxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUU7UUFDdEIsV0FBVyxFQUFFLE1BQU07S0FDcEI7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9